module.exports = __webpack_public_path__ + "../resources/img/ic-re-arrow-left.26946374.svg";